<template>
  <div>
    <DefaultTemplate
      :title="$t('topHeader.signupSpaTitle')"
      :subtitle="$t('topHeader.signupSpaSubTitle')"
      :steps="true"
      stepId="signup"
    />
  </div>
</template>

<script>
import DefaultTemplate from "@/template/DefaultTemplateSpa.vue";

export default {
  name: "signup",
  components: {
    DefaultTemplate,
  },
};
</script>
